import http from './http';
import CrudApi from './crud';

export const crud = new CrudApi('/admin/schools/:schoolId/homework');

export function restoreSchoolHomework(schoolId, homeworkId) {
	return http.put(`/admin/schools/${schoolId}/homework/${homeworkId}/restore`).then(resp => resp.data);
}
